import React from "react";
import "./projects.css";
import Img1 from "../../assets/portfolio1.jpg";
import Img2 from "../../assets/portfolio2.jpg";
import Img3 from "../../assets/portfolio3.jpg";
import Img4 from "../../assets/portfolio4.jpg";
import Img5 from "../../assets/portfolio5.png";
import Img6 from "../../assets/portfolio6.jpg";

const Projects = () => {
  const projectData = [
    {
      id: 1,
      image: Img1,
      title: "GroceryWallah",
      github: "https://github.com/codiac1/GroceryWallah",
      demoLink: "https://github.com/codiac1/GroceryWallah",
    },
    {
      id: 2,
      image: Img2,
      title: "Blog App",
      github: "https://github.com/codiac1/Blog-App",
      demoLink: "https://blog-post-react-app.netlify.app/",
    },
    {
      id: 3,
      image: Img3,
      title: "Phish Man - A ML Solution",
      github: "https://github.com/codiac1/Phishing-URL-detector",
      demoLink: "https://github.com/codiac1/Phishing-URL-detector",
    },
    {
      id: 4,
      image: Img4,
      title: "Student Record App",
      github: "https://github.com/codiac1/Student-Record-WebApp",
      demoLink: "https://student-record-web-app.netlify.app/",
    },
    {
      id: 5,
      image: Img5,
      title: "Tradiction - A ML Solution",
      github: "https://github.com/codiac1/Tradiction",
      demoLink: "https://github.com/codiac1/Tradiction",
    },
    {
      id: 6,
      image: Img6,
      title: "Car Rental Application",
      github: "https://github.com/codiac1",
      demoLink: "https://github.com/codiac1",
    },
  ];

  return (
    <section id="projects">
      <h5>My Recent Works</h5>
      <h2>Projects</h2>
      <div className="container project_container">
        {projectData.map(({ id, image, title, github, demoLink }) => {
          return (
            <article key={id} className="project_item">
              <div className="project_item_image">
                <img src={image} alt="" />
              </div>
              <h3>{title}</h3>
              <div className="project_item_btns">
                <a href={github} className="btn" target="_blank">
                  Github
                </a>
                <a href={demoLink} className="btn btn-primary" target="_blank">
                  Live Demo
                </a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default Projects;
